export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00646.5a730a3f.png";